/* eslint-disable jsx-a11y/img-redundant-alt */
/* Header.js */
import React from 'react';
import './Header.css';

const Header = () => {  
  return (
    <header className="header-container">
      <h1>Berz's Tech Solutions</h1>
    </header>
  );
};

export default Header;
